var render = function render(){var _vm=this,_c=_vm._self._c;return _c('RowContent',{attrs:{"model":_vm.model,"header":_vm.header,"cell":_vm.cell,"statuses":_vm.statuses,"loadingStatus":_vm.loadingStatus,"fullName":[_vm.candidate.name, _vm.candidate.surname].join(' ')},on:{"statusChange":function($event){return _vm.$emit('statusChange', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }